import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { AppRoutes } from "./router";
import ScrollToTop from "./components/feature/ScrollToTop";
import i18n from "./i18n";

/**
 * ルーターの**中身**。実行環境によって変わるのは外枠（Router）だけで、中身はこの1つ。
 *
 *   - ブラウザ:       `App.tsx` が BrowserRouter で包む
 *   - プリレンダー:   `entry-prerender.tsx` が StaticRouter で包む
 *
 * **分けた理由**: BrowserRouter は `window.history` を触るので Node で動かない。
 * かといって中身を2つ書くと必ず片方が腐る（このリポジトリは `descriptionEn` を
 * 並列に置いて英語側だけ腐らせた実績がある）。**外枠だけを差し替える形にして、
 * 中身は物理的に1つしか存在しないようにしてある。**
 *
 * ここに置くものは「ルーターの内側でなければ動かないもの」に限る——
 * ScrollToTop は useLocation を、AppRoutes は useRoutes を使うため。
 */
export default function AppTree() {
  // index.html の <html lang> は初期値でしかない。言語を切り替えたら実体に合わせて
  // 書き換える——読み上げソフトの発音と、ブラウザの翻訳提案の判定がこれを見るため。
  //
  // プリレンダー時は useEffect が走らないので、**静的 HTML 側の lang は
  // index.html の初期値（en）がそのまま残る**。初期言語は常に英語なので一致する。
  useEffect(() => {
    const apply = (lng: string) => {
      document.documentElement.lang = lng;
    };
    apply(i18n.language);
    i18n.on("languageChanged", apply);
    return () => i18n.off("languageChanged", apply);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ScrollToTop />
      <AppRoutes />
    </I18nextProvider>
  );
}
